import styled from 'styled-components';

interface ContainerProps {
  direct: boolean;
}
export const Container = styled.div<ContainerProps>`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: max-content;
      
    background-image: linear-gradient(to top right, ${({ theme }) => theme.borderWordle});
    padding: 0.3rem;

    .row {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
    }
`;

export const GameWrapper = styled.div`
  @media (max-width: 550px) {
    padding: 5px 0;
    margin-bottom: 10px;
  }
`

export const TextContainer = styled.div`
  width: 100%;
  height: 75px;
  padding: 10px;
  background-color: #00000010;
`;
export const Title = styled.p`
  font-size: 18px;
  font-weight: bold;
  color: #000;
`;
export const Text = styled.p`
  font-size:14px;
  color: #000;
`;

export const Row = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

export const ExternalNumbers = styled.div`
position: absolute;
margin-right: 3px;
right: 100%;
top: 23%;
display:flex;
justify-content:center;
align-items:center;
`;

export const ExternalNumbersHorizontal = styled.div`
position: absolute;
bottom: 100%;
`;
